export const user = {
  name: 'Maria',
  surname: 'Luiza',
  recordLocator: 'LJUDWR'
};

export const flights = {
  flightNumber: '4488',
  journeySellKey:
    'AD~4488~ ~~GRU~12/04/2019 18:40~REC~12/04/2019 20:50~^AD~5373~ ~~REC~12/04/2019 22:05~FOR~12/04/2019 23:35~',
  departureStation: 'GRU',
  arrivalStation: 'FOR',
  carrierCode: 'AD',
  std: '2019-12-04T18:40:00',
  sta: '2019-12-04T23:35:00',
  flightInformation: 'Conexão'
};

export const SUGGESTED_FLIGHTS_LIST = {
  success: true,
  data: {
    flightSuggestion: [
      {
        flightNumber: '4488',
        journeySellKey:
          'AD~4488~ ~~GRU~12/04/2019 18:40~REC~12/04/2019 20:50~^AD~5373~ ~~REC~12/04/2019 22:05~FOR~12/04/2019 23:35~',
        departureStation: 'GRU',
        arrivalStation: 'FOR',
        carrierCode: 'AD',
        std: '2019-12-04T18:40:00',
        sta: '2019-12-04T23:35:00',
        flightInformation: 'Conexão'
      },
      {
        flightNumber: '2438',
        journeySellKey:
          'AD~2438~ ~~GRU~12/04/2019 19:25~CNF~12/04/2019 20:45~^AD~2456~ ~~CNF~12/04/2019 23:40~FOR~12/05/2019 01:35~',
        departureStation: 'GRU',
        arrivalStation: 'FOR',
        carrierCode: 'AD',
        std: '2019-12-04T19:25:00',
        sta: '2019-12-05T01:35:00',
        flightInformation: 'Conexão'
      },
      {
        flightNumber: '5016',
        journeySellKey:
          'AD~5016~ ~~GRU~12/04/2019 19:30~SDU~12/04/2019 20:35~^AD~2458~ ~~SDU~12/04/2019 21:40~CNF~12/04/2019 22:45~^AD~2456~ ~~CNF~12/04/2019 23:40~FOR~12/05/2019 01:35~',
        departureStation: 'GRU',
        arrivalStation: 'FOR',
        carrierCode: 'AD',
        std: '2019-12-04T19:30:00',
        sta: '2019-12-05T01:35:00',
        flightInformation: 'Conexão'
      },
      {
        flightNumber: '2522',
        journeySellKey:
          'AD~2522~ ~~GRU~12/04/2019 20:20~CNF~12/04/2019 21:30~^AD~2456~ ~~CNF~12/04/2019 23:40~FOR~12/05/2019 01:35~',
        departureStation: 'GRU',
        arrivalStation: 'FOR',
        carrierCode: 'AD',
        std: '2019-12-04T20:20:00',
        sta: '2019-12-05T01:35:00',
        flightInformation: 'Conexão'
      },
      {
        flightNumber: '2488',
        journeySellKey:
          'AD~2488~ ~~GRU~12/05/2019 05:05~REC~12/05/2019 07:25~^AD~4234~ ~~REC~12/05/2019 08:05~FOR~12/05/2019 09:30~',
        departureStation: 'GRU',
        arrivalStation: 'FOR',
        carrierCode: 'AD',
        std: '2019-12-05T05:05:00',
        sta: '2019-12-05T09:30:00',
        flightInformation: 'Conexão'
      },
      {
        flightNumber: '2410',
        journeySellKey:
          'AD~2410~ ~~GRU~12/05/2019 06:00~CNF~12/05/2019 07:15~^AD~4200~ ~~CNF~12/05/2019 09:45~REC~12/05/2019 11:15~^AD~5346~ ~~REC~12/05/2019 12:25~FOR~12/05/2019 13:50~',
        departureStation: 'GRU',
        arrivalStation: 'FOR',
        carrierCode: 'AD',
        std: '2019-12-05T06:00:00',
        sta: '2019-12-05T13:50:00',
        flightInformation: 'Conexão'
      },
      {
        flightNumber: '2572',
        journeySellKey:
          'AD~2572~ ~~GRU~12/05/2019 09:05~REC~12/05/2019 11:15~^AD~5346~ ~~REC~12/05/2019 12:25~FOR~12/05/2019 13:50~',
        departureStation: 'GRU',
        arrivalStation: 'FOR',
        carrierCode: 'AD',
        std: '2019-12-05T09:05:00',
        sta: '2019-12-05T13:50:00',
        flightInformation: 'Conexão'
      },
      {
        flightNumber: '6954',
        journeySellKey:
          'AD~6954~ ~~GRU~12/05/2019 13:05~REC~12/05/2019 15:30~^AD~2710~ ~~REC~12/05/2019 18:35~FOR~12/05/2019 20:00~',
        departureStation: 'GRU',
        arrivalStation: 'FOR',
        carrierCode: 'AD',
        std: '2019-12-05T13:05:00',
        sta: '2019-12-05T20:00:00',
        flightInformation: 'Conexão'
      },
      {
        flightNumber: '6954',
        journeySellKey:
          'AD~6954~ ~~GRU~12/05/2019 13:05~REC~12/05/2019 15:30~^AD~6901~ ~~REC~12/05/2019 16:45~FOR~12/05/2019 18:15~',
        departureStation: 'GRU',
        arrivalStation: 'FOR',
        carrierCode: 'AD',
        std: '2019-12-05T13:05:00',
        sta: '2019-12-05T18:15:00',
        flightInformation: 'Conexão'
      },
      {
        flightNumber: '4945',
        journeySellKey:
          'AD~4945~ ~~GRU~12/05/2019 15:35~REC~12/05/2019 17:45~^AD~2710~ ~~REC~12/05/2019 18:35~FOR~12/05/2019 20:00~',
        departureStation: 'GRU',
        arrivalStation: 'FOR',
        carrierCode: 'AD',
        std: '2019-12-05T15:35:00',
        sta: '2019-12-05T20:00:00',
        flightInformation: 'Conexão'
      },
      {
        flightNumber: '4488',
        journeySellKey:
          'AD~4488~ ~~GRU~12/05/2019 18:40~REC~12/05/2019 20:50~^AD~5373~ ~~REC~12/05/2019 22:05~FOR~12/05/2019 23:35~',
        departureStation: 'GRU',
        arrivalStation: 'FOR',
        carrierCode: 'AD',
        std: '2019-12-05T18:40:00',
        sta: '2019-12-05T23:35:00',
        flightInformation: 'Conexão'
      },
      {
        flightNumber: '2438',
        journeySellKey:
          'AD~2438~ ~~GRU~12/05/2019 19:25~CNF~12/05/2019 20:45~^AD~2456~ ~~CNF~12/05/2019 23:40~FOR~12/06/2019 01:35~',
        departureStation: 'GRU',
        arrivalStation: 'FOR',
        carrierCode: 'AD',
        std: '2019-12-05T19:25:00',
        sta: '2019-12-06T01:35:00',
        flightInformation: 'Conexão'
      },
      {
        flightNumber: '5016',
        journeySellKey:
          'AD~5016~ ~~GRU~12/05/2019 19:30~SDU~12/05/2019 20:35~^AD~2458~ ~~SDU~12/05/2019 21:40~CNF~12/05/2019 22:45~^AD~2456~ ~~CNF~12/05/2019 23:40~FOR~12/06/2019 01:35~',
        departureStation: 'GRU',
        arrivalStation: 'FOR',
        carrierCode: 'AD',
        std: '2019-12-05T19:30:00',
        sta: '2019-12-06T01:35:00',
        flightInformation: 'Conexão'
      },
      {
        flightNumber: '2522',
        journeySellKey:
          'AD~2522~ ~~GRU~12/05/2019 20:20~CNF~12/05/2019 21:30~^AD~2456~ ~~CNF~12/05/2019 23:40~FOR~12/06/2019 01:35~',
        departureStation: 'GRU',
        arrivalStation: 'FOR',
        carrierCode: 'AD',
        std: '2019-12-05T20:20:00',
        sta: '2019-12-06T01:35:00',
        flightInformation: 'Conexão'
      }
    ],
    message: '',
    success: true
  },
  notifications: null
};

export const mockPost = () => {
  return new Promise((resolve, reject) => {
    const mockSuccess = {
      success: true,
      data: {
        flightNumber: '1234',
        carrierCode: 'AD',
        recordLocator: 'ABC123',
        std: '2019-12-04T18:16:02.1709646-02:00',
        staFinalDestination: '2019-12-04T18:16:02.1709722-02:00',
        departureStation: 'VCP',
        arrivalStationFinalDestination: 'CNF'
      },
      notifications: null
    };

    const mockError = {
      success: false,
      data: null,
      notifications: [
        {
          key: 'ConfirmIropSelfService',
          value: 'Reacomodação já realizada para reserva QH67FK.'
        }
      ]
    };

    const withError = false;

    setTimeout(() => {
      if (withError) {
        resolve(mockError);
      } else {
        resolve(mockSuccess);
      }
    }, 2000);
  });
};
